module.exports = __webpack_public_path__ + "media/images/ux/expression_builder_watermark-f97c819cdb3244bab0201d421bd5c375.png";